import React from 'react';
import '../assets/css/app.css';
import './Paymentmethod.css';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeCard from './StripeCard';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { MasterCardSvg, VisaCardSvg } from './profile-settings/svgs';
import { getCustomerDetails } from '../redux/users/actionCreator';
import { useDispatch } from 'react-redux';
import { Spin } from 'antd';
const stripePromise = loadStripe(process.env.REACT_APP_Stripe_Key);

const PaymentMethod = ({
    getToken,
    setGetToken,
    setStripeToken,
    notes,
    setNotes,
    cardId,
    setCardId,
    setPaymentMethodId,
    paymentType,
    setPaymentType,
    businessDetails,
    paymentMethod,
    setPaymentMethod,
}) => {
    const { userData } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    console.log('businessDetails: ', businessDetails);

    // Get accepted payment method from business settings (new format: 'card', 'cash', or 'both')
    const businessPaymentMethod = businessDetails?.paymentMethod || 'card';

    const isCardAccepted = businessPaymentMethod === 'card' || businessPaymentMethod === 'both';
    const isCashAccepted = businessPaymentMethod === 'cash' || businessPaymentMethod === 'both';

    const handleExistingCard = (id) => {
        setCardId(id);
    };

    useEffect(() => {
        if (userData && userData?.cards?.length === 0) {
            setPaymentMethod('new');
        }
    }, [userData]);

    useEffect(() => {
        if (userData?.cards?.length > 0 && !cardId) {
            const primaryCard = userData.cards.find(card => card.isPrimary) ||
                userData.cards.find(card => card.isBackup) ||
                userData.cards[0];
            if (primaryCard) {
                setCardId(primaryCard.id);
            }
        }
    }, [userData, cardId, setCardId]);

    useEffect(() => {
        dispatch(getCustomerDetails());
    }, []);

    const renderBadge = (card) => {
        const isSingleCard = userData?.cards?.length === 1;
        if (card?.isPrimary || isSingleCard) {
            return (
                <span className="payment-method-badge payment-method-badge--primary">
                    Primary
                </span>
            );
        }

        if (card?.isBackup) {
            return (
                <span className="payment-method-badge payment-method-badge--backup">
                    Backup
                </span>
            );
        }

        return null;
    };

    // Auto-select the only available payment method
    useEffect(() => {
        if (isCardAccepted && !isCashAccepted) {
            setPaymentType('card');
        } else if (isCashAccepted && !isCardAccepted) {
            setPaymentType('cash');
        }
    }, [isCardAccepted, isCashAccepted, setPaymentType]);

    return (
        <div>
            <div>
                <h1 className="lh-40 poly f-36">Review and Confirm</h1>
            </div>
            {!userData?.cards ?
                <div className='d-flex align-items-center justify-content-center'>
                    <Spin />
                </div>
                :
                <>
                    {/* Only show payment type selection if both methods are available */}
                    {isCardAccepted && isCashAccepted && (
                        <>
                            <div className="my-4">
                                <h2 className="poppins fw-600 f-18 lh-24">Payment Type</h2>
                                <p className="poppins f-14 c-667085 mt-1 mb-0">
                                    Choose how you would like to pay for your appointment
                                </p>
                            </div>

                            {/* Payment Type Selection */}
                            <div className="payment-type-selection mb-4">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div
                                            className={`payment-type-card ${paymentType === 'card' ? 'payment-type-selected' : ''}`}
                                            onClick={() => setPaymentType('card')}
                                            role="button"
                                        >
                                            <div className="d-flex align-items-start gap-3">
                                                <input
                                                    type="radio"
                                                    name="paymentType"
                                                    checked={paymentType === 'card'}
                                                    onChange={() => setPaymentType('card')}
                                                    className="mt-1"
                                                />
                                                <div className="flex-grow-1">
                                                    <h4 className="poppins fw-600 f-16 mb-2">Card Payment</h4>
                                                    <p className="poppins f-14 c-667085 mb-0">
                                                        Pay securely with your credit or debit card. You won't be charged now, payment will be collected in store after your appointment.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div
                                            className={`payment-type-card ${paymentType === 'cash' ? 'payment-type-selected' : ''}`}
                                            onClick={() => setPaymentType('cash')}
                                            role="button"
                                        >
                                            <div className="d-flex align-items-start gap-3">
                                                <input
                                                    type="radio"
                                                    name="paymentType"
                                                    checked={paymentType === 'cash'}
                                                    onChange={() => setPaymentType('cash')}
                                                    className="mt-1"
                                                />
                                                <div className="flex-grow-1">
                                                    <h4 className="poppins fw-600 f-16 mb-2">Cash After Service</h4>
                                                    <p className="poppins f-14 c-667085 mb-0">
                                                        Pay with cash after your service is completed. No card details required.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Show message if no payment methods are accepted */}
                    {!isCardAccepted && !isCashAccepted && (
                        <div className="alert alert-warning mt-4" role="alert">
                            <h5 className="poppins fw-600 f-16 mb-2">Payment Methods Not Available</h5>
                            <p className="poppins f-14 mb-0">
                                This business has not configured any payment methods yet. Please contact the business directly to complete your booking.
                            </p>
                        </div>
                    )}

                    {/* Card Payment Section */}
                    {paymentType === 'card' && isCardAccepted && (
                        <>
                            <div className="my-4">
                                <h2 className="poppins fw-600 f-18 lh-24">Payment method</h2>
                                <p className="poppins f-14 c-667085 mt-1 mb-0">
                                    Select or add a payment card
                                </p>
                            </div>
                            {userData?.cards?.length > 0 && (
                                <div className="d-flex justify-content-center mb-4">
                                    <div className="payment-toggle-container">
                                        <button
                                            type="button"
                                            disabled={userData?.cards?.length === 0}
                                            onClick={() => setPaymentMethod('existing')}
                                            className={`payment-toggle-btn ${paymentMethod === 'existing' ? 'active' : ''}`}
                                        >
                                            Select Existing
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setPaymentMethod('new')}
                                            className={`payment-toggle-btn ${paymentMethod === 'new' ? 'active' : ''}`}
                                        >
                                            Add New
                                        </button>
                                    </div>
                                </div>
                            )}
                            {paymentMethod === 'existing' && userData?.cards?.length > 0 ? (
                                <div>
                                    <h2 className="poppins fw-600 f-18 mt-3">
                                        Choose a Saved Payment Method
                                    </h2>
                                    <div className="row mt-3">
                                        {Array.isArray(userData?.cards) &&
                                            userData.cards.map((item, index) => (
                                                <div
                                                    className="col-sm-6 col-12 p-3"
                                                    key={index}
                                                >
                                                    <div
                                                        className={`saved-card-item py-3 px-3 d-flex flex-column justify-content-between cp ${cardId === item.id
                                                            ? 'select-card-bg'
                                                            : ''
                                                            }`}
                                                        style={{ minHeight: '135px' }}
                                                        onClick={() =>
                                                            handleExistingCard(item.id)
                                                        }
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="card-brand-logo">
                                                                {(item?.card?.brand || item?.brand) === 'visa' ? (
                                                                    <VisaCardSvg />
                                                                ) : (item?.card?.brand || item?.brand) ===
                                                                    'mastercard' ? (
                                                                    <MasterCardSvg />
                                                                ) : (
                                                                    <span className="poppins f-14 fw-semibold text-muted">Card</span>
                                                                )}
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2">
                                                                {renderBadge(item)}
                                                                {cardId === item.id && (
                                                                    <div className="card-select-dot"></div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <p className="card-number mb-1 poppins">
                                                                ••••  ••••  ••••  {item?.card?.last4 || item?.last4}
                                                            </p>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <span className="card-type-label poppins f-12">Saved Card</span>
                                                            <span className="card-expiry poppins f-13">
                                                                Exp: {item?.card?.exp_month || item?.exp_month}/
                                                                {item?.card?.exp_year || item?.exp_year}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    <div className="mb-4">
                                        <div className="mb-2 mt-4">
                                            <label className="poppins c-667085 f-14 lh-20">
                                                Booking notes
                                            </label>
                                        </div>
                                        <div>
                                            <textarea
                                                value={notes}
                                                onChange={(e) => setNotes(e.target.value)}
                                                type="textarea"
                                                rows="5"
                                                placeholder="Include comments or requests about your booking"
                                                className="w-100 booking-notes-input"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Elements stripe={stripePromise}>
                                    <StripeCard
                                        setStripeToken={setStripeToken}
                                        getToken={getToken}
                                        setGetToken={setGetToken}
                                        notes={notes}
                                        setNotes={setNotes}
                                        setPaymentMethodId={setPaymentMethodId}
                                    />
                                </Elements>
                            )}
                        </>
                    )}

                    {/* Cash After Service Section */}
                    {paymentType === 'cash' && isCashAccepted && (
                        <div className="cash-payment-section">
                            <div className="alert alert-info d-flex align-items-start gap-3 p-3 rounded-3" role="alert">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#0dcaf0" />
                                </svg>
                                <div>
                                    <h5 className="poppins fw-600 f-16 mb-2">Payment After Service</h5>
                                    <p className="poppins f-14 mb-0">
                                        You will pay with cash after your service is completed. No payment is required now to confirm your booking.
                                    </p>
                                </div>
                            </div>

                            <div className="mb-4 mt-4">
                                <div className="mb-2">
                                    <label className="poppins c-667085 f-14 lh-20">
                                        Booking notes
                                    </label>
                                </div>
                                <div>
                                    <textarea
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        type="textarea"
                                        rows="5"
                                        placeholder="Include comments or requests about your booking"
                                        className="w-100 booking-notes-input"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </>
            }
        </div>
    );
};

export default PaymentMethod;
